import script from "./QModalDisconnectUser.vue?vue&type=script&setup=true&lang=js"
export * from "./QModalDisconnectUser.vue?vue&type=script&setup=true&lang=js"

import "./QModalDisconnectUser.vue?vue&type=style&index=0&id=0ebb3c70&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ebb3c70"]])

export default __exports__